"use client";

import React, { useEffect } from "react";
import { useInView } from "react-intersection-observer";
import { ResponsiveTableProps } from "./types";
import useElementEvents from "@/hooks/eventing/useElementEvents";
import "./styles.css";

import {
  DEFAULT_USE_IN_VIEW_OPTIONS,
  ElementType,
} from "@/constants/tagular/main";
import { DesktopTable } from "./DesktopTable";
import { MobileBlocks } from "./MobileBlocks";

export default function ResponsiveTable({ children }: ResponsiveTableProps) {
  const { elementViewed } = useElementEvents({
    webElement: {
      elementType: ElementType.Button,
      htmlId: "responsive-table",
      location: "responsive-table",
      text: "responsive-table",
      name: "responsive-table",
    },
  });
  const { ref, inView } = useInView(DEFAULT_USE_IN_VIEW_OPTIONS);

  useEffect(() => {
    if (inView) {
      elementViewed();
    }
  }, [inView, elementViewed]);

  return (
    <div className="w-full" ref={ref}>
      {/* Desktop Table */}
      <DesktopTable>{children}</DesktopTable>
      {/* Mobile Blocks */}
      <MobileBlocks>{children}</MobileBlocks>
    </div>
  );
}
